import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "prompt", "selected", "filename", "submit"]

  browse() {
    this.inputTarget.click()
  }

  fileSelected() {
    const file = this.inputTarget.files[0]
    if (file) {
      this.showSelected(file.name)
    }
  }

  showSelected(filename) {
    this.promptTarget.classList.add("hidden")
    this.selectedTarget.classList.remove("hidden")
    this.filenameTarget.textContent = filename
    this.submitTarget.disabled = false
  }

  clear() {
    this.inputTarget.value = ""
    this.promptTarget.classList.remove("hidden")
    this.selectedTarget.classList.add("hidden")
    this.filenameTarget.textContent = ""
    this.submitTarget.disabled = true
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("csv-dropzone-active")
  }

  dragenter(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("csv-dropzone-active")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("csv-dropzone-active")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("csv-dropzone-active")

    const files = event.dataTransfer.files
    if (files.length > 0 && files[0].name.endsWith(".csv")) {
      this.inputTarget.files = files
      this.showSelected(files[0].name)
    }
  }
}
